'use strict';

import './component.scss';
import 'components/attention';
import 'components/info-action-box';
